const ACTION = {
  CANCEL: 1,
  EDIT: 2,
  RESEND: 3,
  PRINT: 4,
  EDIT_DATE: 5,
  SHOW_CALENDAR: 6,
  EDIT_OCCUPATION: 7,
  EDIT_OCCUPATION_CONFIRM: 8,
  EDIT_BOARD: 9,
  EDIT_BOARD_CONFIRM: 10,
};

const ACTION_LABEL = {
  [ACTION.CANCEL]: 'CANCEL',
  [ACTION.EDIT]: 'EDIT',
  [ACTION.EDIT_DATE]: 'EDIT_DATE',
  [ACTION.RESEND]: 'RESEND',
  [ACTION.PRINT]: 'PRINT',
  [ACTION.SHOW_CALENDAR]: 'SHOW_CALENDAR',
  [ACTION.EDIT_OCCUPATION]: 'EDIT_OCCUPATION',
  [ACTION.EDIT_OCCUPATION_CONFIRM]: 'EDIT_OCCUPATION_CONFIRM',
  [ACTION.EDIT_BOARD]: 'EDIT_BOARD',
  [ACTION.EDIT_BOARD_CONFIRM]: 'EDIT_BOARD_CONFIRM',
};

const CANCEL_OPTION = {
  NOT_TRAVEL: 1,
  ANOTHER_HOTEL: 2,
  CHEAPER_PRICE: 3,
  BOOKING_CHANGE: 4,
  OTHERS: 5,
};

const CES_SURVEY_FEATURE = 'cesSurvey';

const FORMAT_CURRENCY = { currency: 'EUR' };

const FORMAT_DATE = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };

const FORMAT_PAY_LATER_DATE = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  weekday: 'short',
  hour: '2-digit',
  minute: '2-digit',
};

const ERROR = {
  GENERIC: 1,
  ANONIMIZED: 7,
};

const STATE = {
  CONFIRMED: 1,
  CANCELLED: 2,
  POSTPONED: 3,
  COMPLETED: 4,
  POS_ERROR: 5,
};

const TRACKING = 'BOOKING';

export {
  ACTION,
  ACTION_LABEL,
  CANCEL_OPTION,
  CES_SURVEY_FEATURE,
  ERROR,
  FORMAT_CURRENCY,
  FORMAT_DATE,
  FORMAT_PAY_LATER_DATE,
  STATE,
  TRACKING,
};
